import React, {useEffect} from "react";
import { BASE_URL } from "../Config/Base";

const SuperAdmdashboardMain = () => {

    useEffect(()=>{  
        Getusers() 
     },[])
      
    function Getusers() {
        // console.log("Token", token);
        const token = JSON.parse(localStorage.getItem('usertoken'));
        fetch(`${BASE_URL}/User/GetAllUsers`, {
          method: "GET",
    
          headers: {
            "Content-type": "application/json",
    
            Accept: "application/json",
    
            Authorization: "Bearer " + `${token}`,
    
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
          },
    
          //body:JSON.stringify(data)
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Data", data);
            // setAllusers(data);
            // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
            localStorage.setItem("SA-users", JSON.stringify(data));
          });
    
    
      }
    

  return (
    <>
  <div className="sa-addmain">
  <div className="sa-addgrid-layout" style={{opacity:"0"}}>
    <div className="sa-addmain-top">
        <div className='sa-addmain-back'>
           
        </div> 
           <span>Welcome to Your Profile</span>
 

     </div>
 </div>
     <div  className="sa-dashboard"><h2 style={{fontWeight:"800"}}>Welcome To Venture Dashboard</h2>
 
  </div>
 
  </div> 
  </>
  )
}

export default SuperAdmdashboardMain